export default `
  query listGitHubRepoFiles($login: String!, $owner: String!, $repo: String!, $folder: String, $branch: String) {
    listGitHubRepoFiles(login: $login, owner: $owner, repo: $repo, folder: $folder, branch: $branch) {
      success
      errorText
      resData {
        path
        name
        type
        sha
        size
      }
    }
  }
`
